import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';

import {
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { WarehouseRestockStatusComponent } from '../warehouse-restock-status/warehouse-restock-status.component';
import { WarehouseRestockTypeComponent } from '../warehouse-restock-type/warehouse-restock-type.component';
import { WarehouseRestockCollectionItem } from '../../models/warehouse-restock-collection-item';
import { WarehouseRestockCollectionFilter } from '../../models/warehouse-restock-collection-filter';
import { isNil, isNotNil } from '@web/utils';
import { Tooltip } from 'primeng/tooltip';
import { WarehouseOrderEventBusService } from '../../bus/services/warehouse-order-event-bus.service';
import { WarehouseOrderPreviewBusEvent } from '../../bus/events/warehouse-order-preview-bus.event';

@Component({
  selector: 'app-warehouse-restock-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    WarehouseRestockStatusComponent,
    WarehouseRestockTypeComponent,
    NoDataComponent,
    Tooltip,
  ],
  templateUrl: './warehouse-restock-list-custom-cell-template.component.html',
  styleUrl: './warehouse-restock-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseRestockListCustomCellTemplateComponent {
  private readonly eventBus = inject(WarehouseOrderEventBusService);

  /* prettier-ignore */
  public readonly column = input.required<TableColumn<WarehouseRestockCollectionItem, WarehouseRestockCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<WarehouseRestockCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<WarehouseRestockCollectionItem>;
  protected readonly isNotNil = isNotNil;

  public handleShowOrderDetailsClick(): void {
    const orderId = this.model().orderId;

    if (isNil(orderId)) {
      return;
    }

    this.eventBus.publish(new WarehouseOrderPreviewBusEvent({ orderId }));
  }
}
